import React from 'react';
import { Helmet } from 'react-helmet';
import useToggle from '../../Hooks/useToggle';
import BackToTop from '../BackToTop';
import FooterHomeOne from '../Footer/FooterHomeThree';
import HeaderNews from '../Header/HeaderNews';
import HeroNews from '../Header/HeroNews';
import Drawer from '../Mobile/Drawer';
import Forms from './Forms';

function Contact() {
    const [drawer, drawerAction] = useToggle(false);

    return (
        <>
            <Helmet>
                <meta
                    name="description"
                    content="Talk to the OTO team in Kigali: ask for a demo, a quote or help with your account."
                />
                <title>Contact OTO by Kapp | Ask for a Demo or a Quote</title>
            </Helmet>
            <Drawer drawer={drawer} action={drawerAction.toggle} />
            <HeaderNews drawer={drawer} action={drawerAction.toggle} />
            <main>
                <HeroNews
                    title="Contact Us"
                    breadcrumb={[
                        { link: '/', title: 'Home' },
                        { link: '/contact', title: 'Contact' },
                    ]}
                />
                <Forms />
            </main>
            <FooterHomeOne className="appie-footer-about-area" />
            <BackToTop />
        </>
    );
}

export default Contact;
